/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
*/
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Shield, BookOpen } from 'lucide-react';

const arcaneTitle = require('ressources/images/arcaneFeedMaxTitle.png')

interface IHeaderProps {
  onClick: () => void;
  isAdmin?: boolean;
}

const Header: React.FC<IHeaderProps> = ({ onClick, isAdmin = false }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const isAdminPage = location.pathname === '/admin';
  const isReleaseNotesPage = location.pathname === '/release-notes';

  const isProduction = process.env.REACT_APP_ENV === 'production';
  const color = isProduction ? 'gray' : 'red';

  return (
    <header className={`w-full py-4 px-8 border-b border-gray-700 bg-${color}-800/30 backdrop-blur-sm sticky top-0 z-50`}>
      <div className="relative flex items-center justify-center">
        {/* Logo - centered */}
        <div className="flex items-center gap-3">
          <img src={arcaneTitle} alt='ai-conic' style={{height: 40, cursor: 'pointer'}} onClick={onClick}/>
        </div>
        
        {/* Action buttons - absolute positioned on the right */}
        <div className="absolute right-4 flex items-center gap-3">
          {/* Release Notes button - always visible */}
          <button
            onClick={() => isReleaseNotesPage ? navigate(-1) : navigate('/release-notes')}
            className="flex items-center gap-2 px-4 py-2 bg-blue-600/20 hover:bg-blue-600/30 border border-blue-500/30 rounded-lg transition-colors text-blue-300 hover:text-blue-200"
            title={isReleaseNotesPage ? 'Go Back' : 'Release Notes'}
          >
            <BookOpen className="w-4 h-4" />
            <span className="text-sm font-medium">{isReleaseNotesPage ? 'Go Back' : 'Release Notes'}</span>
          </button>

          {/* Admin button - only visible for admins */}
          {isAdmin && (
            <button
              onClick={() => isAdminPage ? navigate(-1) : navigate('/admin')}
              className="flex items-center gap-2 px-4 py-2 bg-purple-600/20 hover:bg-purple-600/30 border border-purple-500/30 rounded-lg transition-colors text-purple-300 hover:text-purple-200"
              title={isAdminPage ? 'Go Back' : 'Admin Panel'}
            >
              <Shield className="w-4 h-4" />
              <span className="text-sm font-medium">{isAdminPage ? 'Go Back' : 'Admin'}</span>
            </button>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
